import '../shared/bootstrap'
import moment from 'moment-timezone'
import VueApexCharts from 'vue-apexcharts'

import store from './store'
import safeHtml from './plugins/safe-html'

require('vue2-autocomplete-js/dist/style/vue2-autocomplete.css')
// require('vue-good-table/dist/vue-good-table.css')
// this package is locked/fixed, bacause the style is copied to match datatables
require('./search/vue-good-table.css')
require('../../css/vue-tour.css')

Vue.use(safeHtml)

Vue.component('Apexchart', VueApexCharts)

Vue.component('ColloquiumView', () => import('../shared/colloquium/ColloquiumView.vue'))
Vue.component('SearchComponent', () => import('./search/SearchComponent.vue'))
Vue.component('AdvancedSearchComponent', () => import('./search/AdvancedSearchComponent.vue'))

Vue.component('ColloquiumView', () => import('../shared/colloquium/ColloquiumView.vue'))
Vue.component('SearchComponent', () => import('./search/SearchComponent.vue'))
Vue.component('AdvancedSearchComponent', () => import('./search/AdvancedSearchComponent.vue'))

Vue.component('ShowResult', () => import('../shared/review/views/employees/ShowResult.vue'))
Vue.component('ShowEventResult', () => import('../shared/review/views/employees/ShowEventResult.vue'))
Vue.component('QuestionAggregationView', () => import('../shared/review/components/analytics/QuestionAggregationView.vue'))

Vue.component('VueQueryFilter', () => import('./components/QueryBuilder.vue'))
Vue.component('VueQueryDisplay', () => import('./components/EventFilter/EventFilter.vue'))
Vue.component('Suggest', () => import('./components/Suggest.vue'))
Vue.component('CreateSyncActions', () => import('./components/ScheduleSyncRules/CreateSyncActions.vue'))
Vue.component('CreateSsrSteps', () => import('./components/ScheduleSyncRules/CreateSsrSteps.vue'))
Vue.component('RegistrationSettings', () => import('./registration_settings/components/RegistrationSettings.vue'))
Vue.component('GeneralStepper', () => import('./components/GeneralStepper.vue'))
Vue.component('ExamInfo', () => import('./components/ExamSubscribables/ExamInfo.vue'))

/* attendance-list 2.0 */
Vue.component('AttendanceList', () => import('./AttendanceList/components/AttendanceList.vue'))

/* Dynamic Qr codes */
Vue.component('SingleKeyRp', () => import('./DynamicKey/SingleKeyRp.vue'))
Vue.component('TimeKeyRp', () => import('./DynamicKey/TimeKeyRp.vue'))
Vue.component('ClassroomTimeKeyRp', () => import('./DynamicKey/ClassroomTimeKeyRp.vue'))

/* tours */
Vue.component('StartTour', () => import('./components/StartTour'))
Vue.component('EmployeeFirstLoginTour', () => import('./components/EmployeeFirstLoginTour.vue'))
Vue.component('AttendanceListTour', () => import('./AttendanceList/components/AttendanceListTour.vue'))

/* attendance goals */
Vue.component('AttendanceGoalSteps', () => import('./components/AttendanceGoal/Steps.vue'))
Vue.component('AttendanceGoalPreview', () => import('./components/AttendanceGoal/Preview.vue'))
Vue.component('AttendancePage', () => import('./components/AttendancePage/AttendancePage.vue'))
Vue.component('AttendanceGoalMatrixOverview', () => import('./components/AttendanceGoal/AttendanceGoalMatrixOverview.vue'))

/* Subscribables */
Vue.component('ExamSubscribablesSteps', () => import('./components/ExamSubscribables/Steps.vue'))
Vue.component('EventserieSubscribablesSteps', () => import('./components/EventSerieSubscribables/Steps.vue'))
Vue.component('EventserieSubscribablesPreview', () => import('./components/EventSerieSubscribables/Preview.vue'))
Vue.component('SubscribableGroupingSteps', () => import('./components/SubscribableGrouping/Steps.vue'))
Vue.component('GeneralSubscriptionsMatrixOverview', () => import('./components/Subscribable/GeneralSubscriptionsMatrixOverview.vue'))
Vue.component('SubscribableGroupingAnswersOverview', () => import('./components/Subscribable/SubscribableGroupingAnswersOverview.vue'))

/* Lessons */
Vue.component('CourseAttendanceMatrixOverview', () => import('./components/Lessons/CourseAttendanceMatrixOverview.vue'))
Vue.component('GroupAttendanceMatrixOverview', () => import('./components/Lessons/GroupAttendanceMatrixOverview.vue'))
Vue.component('MentorStudentsAttendanceMatrixOverview', () => import('./components/Lessons/MentorStudentsAttendanceMatrixOverview.vue'))

/* Analytics */
Vue.component('ReviewLecturerAnalytics', () => import('./../shared/review/components/analytics/LecturerAnalytics.vue'))
Vue.component('ApiLogAnalytics', () => import('./components/ApiLogAnalytics.vue'))

/* Werkplekken */
Vue.component('EmployeeWerkplekkenCalendar', () => import('./components/Werkplekken/EmployeeWerkplekkenCalendar.vue'))

/* StudyPlan */
Vue.component('StudyPlan', () => import('./studyplan/StudyPlanEmployee.vue'))
Vue.component('StudentAdvise', () => import('./advise/StudentAdviseDashboard.vue'))

/* ClassificationConfigs */
Vue.component('ClassificationConfigSteps', () => import('./components/ClassificationConfig/ClassificationConfigSteps.vue'))

Vue.component('Loader', () => import('./components/Loader.vue'))

/* Rule */
//* All the rule components are registerd this way, to work around the circular references problem within in Vue 2
//* The link bellow explains the problem and the solution to it, the other two suggested solutions did not seem to work.
//* https://v2.vuejs.org/v2/guide/components-edge-cases.html#Circular-References-Between-Components
Vue.component('RuleAdd', () => import('./components/Rule/RuleAdd.vue'))
Vue.component('RuleComposite', () => import('./components/Rule/RuleComposite.vue'))
Vue.component('RuleIfElse', () => import('./components/Rule/RuleIfElse.vue'))
Vue.component('RuleIfElseCondition', () => import('./components/Rule/RuleIfElseCondition.vue'))
Vue.component('RuleMinMaxCount', () => import('./components/Rule/RuleMinMaxCount.vue'))
Vue.component('RuleMinMaxCountCondition', () => import('./components/Rule/RuleMinMaxCountCondition.vue'))
Vue.component('RuleMinMaxCountFilterCondition', () => import('./components/Rule/RuleMinMaxCountFilterCondition.vue'))
Vue.component('RuleNot', () => import('./components/Rule/RuleNot.vue'))
Vue.component('RuleOverlap', () => import('./components/Rule/RuleOverlap.vue'))
Vue.component('RuleAggregate', () => import('./components/Rule/RuleAggregate.vue'))
Vue.component('RuleAggregateValue', () => import('./components/Rule/RuleAggregateValue.vue'))
Vue.component('RuleSelect', () => import('./components/Rule/RuleSelect.vue'))
Vue.component('RuleSelectOperator', () => import('./components/Rule/RuleSelectOperator.vue'))
Vue.component('RuleSpecificSubscription', () => import('./components/Rule/RuleSpecificSubscription.vue'))
Vue.component('RuleTypeShow', () => import('./components/Rule/RuleTypeShow.vue'))
Vue.component('RuleDescription', () => import('./components/Rule/RuleDescription.vue'))
Vue.component('RuleDescriptionTranslation', () => import('./components/Rule/RuleDescriptionTranslation.vue'))
Vue.component('RuleDescriptionAdd', () => import('./components/Rule/RuleDescriptionAdd.vue'))
/* Utilities Rule */
Vue.component('RuleBuilder', () => import('./components/Rule/utilities/RuleBuilder.vue'))
Vue.component('RuleHeader', () => import('./components/Rule/utilities/RuleHeader.vue'))
Vue.component('RulePropertyRemove', () => import('./components/Rule/utilities/RulePropertyRemove.vue'))
Vue.component('RuleRemove', () => import('./components/Rule/utilities/RuleRemove.vue'))
Vue.component('RuleSmallButton', () => import('./components/Rule/utilities/RuleSmallButton.vue'))
Vue.component('RuleWrapper', () => import('./components/Rule/utilities/RuleWrapper.vue'))
Vue.component('RuleCaret', () => import('./components/Rule/utilities/RuleCaret.vue'))

/* Selector */
//* All the selector components are registerd this way, to work around the circular references problem within in Vue 2
//* The link bellow explains the problem and the solution to it, the other two suggested solutions did not seem to work.
//* https://v2.vuejs.org/v2/guide/components-edge-cases.html#Circular-References-Between-Components
Vue.component('SelectorAdd', () => import('./components/Selector/SelectorAdd.vue'))
Vue.component('SelectorComposite', () => import('./components/Selector/SelectorComposite.vue'))
Vue.component('SelectorNot', () => import('./components/Selector/SelectorNot.vue'))
Vue.component('SelectorSelect', () => import('./components/Selector/SelectorSelect.vue'))
Vue.component('SelectorSelectOperator', () => import('./components/Selector/SelectorSelectOperator.vue'))
Vue.component('SelectorSelectOperator', () => import('./components/Selector/SelectorSelectOperator.vue'))
Vue.component('SelectorSubscribable', () => import('./components/Selector/SelectorSubscribable.vue'))
Vue.component('SelectorTypeShow', () => import('./components/Selector/SelectorTypeShow.vue'))
Vue.component('SelectorSubscribableGrouping', () => import('./components/Selector/SelectorSubscribableGrouping.vue'))
Vue.component('SelectorGroup', () => import('./components/Selector/SelectorGroup.vue'))
Vue.component('SelectorMentor', () => import('./components/Selector/SelectorMentor.vue'))
Vue.component('SelectorStudentCharacteristic', () => import('./components/Selector/SelectorStudentCharacteristic.vue'))
/* Utilities Selector */
Vue.component('SelectorBuilder', () => import('./components/Selector/utilities/SelectorBuilder.vue'))
Vue.component('SelectorHeader', () => import('./components/Selector/utilities/SelectorHeader.vue'))
Vue.component('SelectorRemove', () => import('./components/Selector/utilities/SelectorRemove.vue'))
Vue.component('SelectorWrapper', () => import('./components/Selector/utilities/SelectorWrapper.vue'))

Vue.component('AssessmentConfigFlowView', () => import('./components/AssessmentConfig/view/AssessmentConfigFlowView.vue'))
Vue.component('CreateOrUpdateSystemMessage', () => import('./components/SystemMessage/CreateOrUpdateSystemMessage.vue'))

/* V components */
Vue.component('VTextBox', () => import('./components/VTextBox.vue'))
Vue.component('VStepper', () => import('./components/VStepper.vue'))
Vue.component('VInputWrapper', () => import('./components/VInputWrapper.vue'))

// set the default timezone
process.env.MIX_TIMEZONE !== undefined ? moment.tz.setDefault(process.env.MIX_TIMEZONE) : moment.tz.setDefault('Europe/Amsterdam')

if (document.getElementById('vue-app-employee')) {
  const app = new Vue({
    el: '#vue-app-employee',
    store,
  })
}

if (document.getElementById('vue-tour')) {
  const vueapp = new Vue({
    el: '#vue-tour',
  })
}
